import type { PartialTheme } from "@fluentui/theme";
import { fullDensity } from "./densities/full";

// TODO WI 116002: use getCurrentDensity in the future when we configure the styles for fluent controls
export default function getCurrentDensity(_selectedDensityMode?: string | undefined): PartialTheme {
    return fullDensity;
}
